import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const base_url = process.env.REACT_APP_API_URL;

export default function PendingDeposite() {

  const token = localStorage.getItem("admin_token");

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  // 🔹 Fetch deposits
  const fetchDeposits = async () => {
    try {

      const res = await axios.get(
        `${base_url}/api/admin/deposits`,
        {
          headers: { Authorization: token }
        }
      );

      if (res.data.success) {
        setData(res.data.data);
      }

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDeposits();
  }, []);

  // 🔹 Confirm / Reject popup
  const updateStatus = async (item, status) => {

    if (status === 1) {

      const confirm = await Swal.fire({
        title: "Confirm Deposit?",
        text: `Approve deposit ₹${item.amount}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Confirm",
      });

      if (!confirm.isConfirmed) return;

      await sendStatus(item.id, 1, "");

    } else {

      const { value: remark } = await Swal.fire({
        title: "Reject Deposit",
        input: "text",
        inputLabel: "Remark (required)",
        inputPlaceholder: "Enter rejection reason",
        showCancelButton: true,
        confirmButtonText: "Reject",
        inputValidator: (value) => {
          if (!value) {
            return "Remark is required!";
          }
        }
      });

      if (remark) {
        await sendStatus(item.id, 2, remark);
      }

    }

  };

  // 🔹 API call
  const sendStatus = async (id, status, remark) => {

    try {

      const res = await axios.post(
        `${base_url}/api/admin/update-deposit-status`,
        { id, status, remark },
        { headers: { Authorization: token } }
      );

      if (res.data.success) {
        toast.success("Status updated");
        fetchDeposits();
      } else {
        toast.error(res.data.message);
      }

    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }

  };

  // 🔹 Status label
  const getStatus = (status) => {
    if (status === 0) return <span className="badge bg-warning">Pending</span>;
    if (status === 1) return <span className="badge bg-success">Confirmed</span>;
    if (status === 2) return <span className="badge bg-danger">Rejected</span>;
  };

  // 🔹 Search filter
  const filteredData = data.filter((item) =>
    item.phone?.toString().includes(search) ||
    item.transaction_id?.toString().includes(search) ||
    item.method?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="px-3 px-md-4">

      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">

        <h4 className="mb-2">Deposit Requests</h4>

        <input
          type="text"
          placeholder="Search..."
          className="form-control w-auto"
          style={{ minWidth: "250px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      <div className="card shadow-sm">

        <div className="table-responsive">

          <table className="table table-hover align-middle mb-0">

            <thead className="table-dark">

              <tr>
                <th>#</th>
                <th>Phone</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Transaction</th>
                <th>Proof</th>
                <th>Status</th>
                <th>Action</th>
              </tr>

            </thead>

            <tbody>

              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (

                  <tr key={item.id}>

                    <td>{index + 1}</td>

                    <td>{item.phone}</td>

                    <td className="fw-bold text-success">
                      ₹{item.amount}
                    </td>

                    <td>{item.method}</td>

                    <td>{item.transaction_id}</td>

                    {/* Proof */}
                    <td>
                      {item.proof ? (
                        <img
                          src={`${base_url}/uploads/${item.proof}`}
                          alt="proof"
                          width="40"
                          style={{
                            cursor: "pointer",
                            borderRadius: "5px"
                          }}
                          onClick={() =>
                            Swal.fire({
                              imageUrl: `${base_url}/uploads/${item.proof}`,
                              imageWidth: 400,
                              showConfirmButton: false
                            })
                          }
                        />
                      ) : (
                        "-"
                      )}
                    </td>

                    {/* Status */}
                    <td>{getStatus(item.status)}</td>

                    {/* Action */}
                    <td>

                      {item.status === 0 && (
                        <div className="d-flex gap-2">

                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => updateStatus(item, 1)}
                          >
                            Confirm
                          </button>

                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => updateStatus(item, 2)}
                          >
                            Reject
                          </button>

                        </div>
                      )}

                    </td>

                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    No deposit requests found
                  </td>
                </tr>
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}